import axios from "axios";

function requestSurNameList(parameter) {
  return axios.get(
    `${process.env.VUE_APP_APIURL}/api/app/tablet/surName/list?keyword=` +
      encodeURIComponent(parameter.keyword)
  );
}

const requestAddSurName = parameter => {
  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/app/tablet/surName/add`,
    parameter
  );
};

export { requestSurNameList, requestAddSurName };
